import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  & + & {
    margin-top: 8px;
  }
`;

export const IconCell = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  min-width: 30px;
  margin-right: 10px;
`;

export const AddonIcon = styled.img`
  width: 18px;
  height: 18px;
`;

export const Title = styled.span`
  flex: 1;
`;

export const Price = styled.span`
  margin-left: 10px;
  white-space: nowrap;
  color: ${(props) => props.theme.black50};
`;
